module.exports = __webpack_public_path__ + "static/media/Remove-Box.05e31071.svg";